export { default } from "./CustomersTemplate"